
/** 
 * @Desc: 视频播放容器
 */
<template>
  <div class="fill video-div-box" ref="videoComponent">
    <el-dialog
      title="温馨提示"
      width="30%"
      :visible.sync="tryModel"
      :close-on-click-modal="false"
      :lock-scroll="false"
      @click.stop="_hideModle"
    >
      <div class="try-txt">抱歉，您的试看时间已结束！</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="_tryAgein">重新试看</el-button>
        <el-button size="small" @click="tryModel = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- ppt全屏时，假的视频全屏 -->
    <div v-if="fullscreenFlag" class="mask">
      <div class="viewer-video-wrapper center" id="wrapper">
        <i class="iconfont iconclose viewer-video-close" @click.stop="$emit('handleClose')"></i>
        <!-- 视频的容器 -->
        <div class="playerWrapper" id="videoDivBox"></div>
      </div>
    </div>
    <div v-else id="videoDivBox" style="position: relative;width: 100%;height: 100%"></div>

    <div class="video-try-see" v-show="isTrailer1">
      <p v-if="trailerDuration !== -1">可试看{{trailerDuration}}s</p>
      <p v-else>可试看全部</p>
      <img src="../../assets/close.png" alt @click.stop="_hideTrySee" />
    </div>
    <div v-show="messageBox" class="messag-box">
      <p class="center">很抱歉，建议使用Google Chrome浏览器进行播放</p>
    </div>
  </div>
</template>

<script>
// import video1 from '../../../public/static/lib/video.js';
import {
  enterFullScreen,
  exitFullScreen,
  isFullscreen,
  debounce,
  localStorageUtil
} from "utils/util";
import { SetVideoStatistics } from 'api/common';
export default {
  props: {
    resourceId: {
      type: [String, Number],
      required: false
    },
    videoUrl: {
      type: String,
      required: true,
      default: ""
    },
    coverUrl: {
      type: String,
      required: true,
      default: ""
    },
    tValue: {
      type: String,
      required: false,
      default: ""
    },
    enValue: {
      type: String,
      required: false,
      default: ""
    },
    zhValue: {
      type: String,
      required: false,
      default: ""
    },
    enAndzhValue: {
      type: String,
      required: false,
      default: ""
    },
    trailerDuration: {
      type: Number
    },
    isTrailer: {
      type: Boolean,
      default: false
    },
    fullscreenFlag: {
      type: Boolean,
      default: false
    },
    compatibleFullScreen: {
      type: Boolean,
      default: false
    },
    hadLogo: { // 是否有logo：true-有 false-没有
      type: Boolean,
      default: true
    },
    level: { // level
      type: [Number, String],
      default: 2
    },
    subject: { // subject
      type: [Number, String],
      default: 0
    },
    fromPopUp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      videoObj: {},
      messageBox: false,
      tryModel: false,
      isTrailer1: this.isTrailer
    };
  },
  watch: {
    videoUrl: {
      immediate: true,
      handler(newValue) {
        let accountInfo = localStorageUtil.getItem('accountInfo');
        let userInfo = localStorageUtil.getItem('userInfo');
        if(!userInfo) {
          userInfo = {};
        }
        // console.log('videoUrl:', newValue, 'coverUrl:', this.coverUrl);
        if (newValue && newValue.indexOf("http") === -1) {
          // vs4
          // 配置video需要的参数
          this.$nextTick(() => {
            // 设置video的元素
            let _l = newValue.split('/');
            let _id = _l[_l.length - 1];
            document.getElementById("videoDivBox").innerHTML = `<video id="videoEle" 
              class="fill" 
              resourceid="${_id}" 
              init="true" 
              ></video>`;
            if (window.Module.isSupportViewBoxPlayer()) {
              var subtitleObj = {
                en: this.enValue,
                zh: this.zhValue,
                "en&zh-cn": this.enAndzhValue
              };
              var temp = {};
              temp.subtitle = subtitleObj;
              temp.wrap = document.getElementById("videoEle");
              temp.videouri = this.videoUrl;
              // console.log('----', this.coverUrl, this.fullscreenFlag);
              temp.videoposter = this.coverUrl;
              temp.t = this.tValue;
              temp.autoplay = true;
              if(this.hadLogo) {
                temp.logo = false;
              }else {
                temp.logo = {
                  width: '13.28%',
                  height: '5.5556%',
                  top: '3.7%',
                  right: '2.08%',
                  transform: 'none',
                  backgroundSize: '100%'
                }
              }
              if (this.isTrailer && this.trailerDuration !== -1) {
                temp.limittime = this.trailerDuration;
                temp.playcb = () => {
                  console.log("exceed timelimit");
                  this.tryModel = true;
                };
              }
              // 给视频对象进行配置
              temp.nofullscreen = this.fullscreenFlag;

              let ss = window.Module.createViewBoxPlayer(temp);
              this.videoObj = ss;
              // play方法必须使用
              ss.play();
              // 监听页面关闭事件
              window.addEventListener("beforeunload", this._beforeunloadEvent);
              SetVideoStatistics({
                resourceId: _id,
                level: this.level,
                subject: this.subject
              });
            } else {
              this.messageBox = true;
            }
            this._judgeSelfFullScreen();
            this.isTrailer1 = this.isTrailer;
          });
        } else if (newValue && newValue.indexOf("http") === 0) {
          // mp4
          const demoUrl =
            "http://mvr-learning.viewshare.net/source/新增资源1/微课/DTT_0308.mp4";
          let videoEle = `<video 
            src="${this.videoUrl}" 
            width="100%" 
            id="H5Video" 
            height="100%" 
            controls="controls" 
            autoplay="autoplay" 
            oncontextmenu="return false" 
            controlslist="nodownload 
            fullscreen noremoteplayback" 
            />`
          this.$nextTick(() => {
            document.getElementById("videoDivBox").innerHTML = videoEle;
            document.querySelector("#videoDivBox video")[
              "disablePictureInPicture"
            ] = true;
            if (this.fullscreenFlag) {
              document
                .querySelector("#videoDivBox video")
                .setAttribute(
                  "controlslist",
                  "nodownload nofullscreen noremoteplayback"
                );
            }
            let videoboxplayer_volume = localStorage.getItem('videoboxplayer_volume');
            if(videoboxplayer_volume) {
              videoboxplayer_volume = Number(videoboxplayer_volume);
            }else {
              videoboxplayer_volume = 0.5;
            }
            document.querySelector("#videoDivBox video").volume = videoboxplayer_volume;
            var eventTester = function(e){
              document.querySelector("#videoDivBox video").addEventListener(e,function(){
                document.querySelector("#videoDivBox video").volume = this.volume;
                localStorageUtil.setItem('videoboxplayer_volume', this.volume);
              },false);
            }
            eventTester("volumechange"); //音量改变
            if(this.resourceId) {
              SetVideoStatistics({
                resourceId: this.resourceId,
                level: this.level,
                subject: this.subject
              });
            }
          });
        }
        // 当点击其他视频的时候，先清空数据
        else {
          document.getElementById("videoDivBox").innerHTML = "";
        }
      }
    },
    isTrailer(val) {
      this.isTrailer1 = val;
    }
  },
  methods: {
    /**
     * 设置DOM
     */
    _setDomStyle: function() {
      let ele = document.querySelector("#wrapper");
      let closeEle = document.querySelector(".viewer-video-close");
      let voiceBtn = document.querySelector("#viewshareplayervolume");
      let fullBtn = document.querySelector("#viewshareplayerflsn");
      ele.style.width = screen.width + "px";
      ele.style.height = screen.height + "px";
      closeEle.style.top = "25px";
      closeEle.style.right = "10px";
      closeEle.style.zIndex = 9;
      fullBtn.style.display = "none";
      voiceBtn.style.right = "20px";
      voiceBtn.addEventListener("click", this._setVoiceBarCSS);
    },

    /**
     * 设置音量的样式
     */
    _setVoiceBarCSS: function() {
      this.$nextTick(() => {
        let voiceBar = document.querySelector("#viewshareplayervolumebar");
        voiceBar.style.right = "20px";
      });
    },

    /**
     * 视频的停止播放方法
     */
    _videoPause: function() {
      this.videoObj && this.videoObj.stop && this.videoObj.stop();
      if (document.getElementById("videoDivBox")) {
        document.getElementById("videoDivBox").innerHTML = "";
      }
    },

    /**
     * 监听的页面关闭事件
     */
    _beforeunloadEvent: function(event) {
      this._videoPause();
    },
    _hideTrySee() {
      this.isTrailer1 = false;
    },
    _hideModle() {
      this.tryModel = false;
    },
    _tryAgein() {
      this.tryModel = false;
      document.querySelector("#videoEle").currentTime = 0;
      document.querySelector("#videoEle").play();
    },

    /**
     * 是否要自定义视频全屏
     */
    _judgeSelfFullScreen(e) {
      if (this.isTrailer && !this.fullscreenFlag) {
        // let fullBtn = document.querySelector("#viewshareplayerflsn");
        setTimeout(() => {
          $("#viewshareplayerflsn").attr("id", "viewshareplayerflsn_new");
          $("#uilayer").on("click", "#viewshareplayerflsn_new", e =>
            this._selfFullScreenClick(e)
          );
        }, 500);
      }
    },

    /**
     * 自定义视频全屏事件
     */
    _selfFullScreenClick(e) {
      if (isFullscreen()) {
        exitFullScreen(this.$refs.videoComponent);
      } else {
        enterFullScreen(this.$refs.videoComponent);
      }
    }
  },
  mounted() {
    if (this.fullscreenFlag) {
      this.$nextTick(() => {
        this._setDomStyle();
        // 设置一个定时，保证在视频数据加载之后在调用play方法（确保教师端我的收藏和素材库视频显示）
        // setTimeout(() => {
        //   this.videoObj.play && this.videoObj.play();
        // }, 500);
      });
    }
  },
  destroyed: function() {
    this._videoPause();
    if (
      $("#uilayer").find("#viewshareplayerflsn_new") &&
      $("#uilayer").find("#viewshareplayerflsn_new")[0]
    ) {
      $("#uilayer").off(
        "click",
        "#viewshareplayerflsn_new",
        this._judgeSelfFullScreen
      );
    }
  }
};
</script>

<style lang="less" scoped>
/* 按需引入变量和方法 */
// @import '~style/base';

.video-div-box {
  position: relative;

  /* 信息提示框子 */
  .messag-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    p {
      color: white;
    }
  }
}

.video-try-see {
  position: absolute;
  bottom: 50px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  left: 3%;
  padding: 5px;
  border-radius: 5px;
  font-size: 12px;
  align-items: center;

  p {
    margin-right: 5px;
    color: #fff;
  }

  img:hover {
    cursor: pointer;
  }
}

.video-div-model {
  position: absolute;
  z-index: 99;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .video-model-info {
    position: relative;
    width: 32.8%;
    height: 31.8%;
    background: #FFFFFF;
    box-shadow: 0 10px 40px 0 rgba(19, 107, 87, 0.05);
    border-radius: 10px;
    padding: 1.6%;
    display: flex;

    img {
      position: absolute;
      top: 6.6%;
      right: 5.6%;
    }

    .model-text {
      p {
        // font-size: 24px;
        color: #262626;
        letter-spacing: 0;
        text-align: center;
        line-height: 24px;
      }
    }

    .model-button {
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: flex-end;

      button {
        width: 45%;
      }
    }
  }
}

/deep/.el-dialog {
  margin-top: 36vh !important;
  max-width: 476px !important;
  max-height: 280px !important;

  .try-txt {
    text-align: center;
    color: #002E36;
  }
}

.w1480 {
  .model-text {
    p {
      font-size: 24px;
    }
  }

  .model-button {
    button {
      height: 40px;
    }
  }

  .try-txt {
    height: 100px;
    line-height: 80px;
    font-size: 16px;
  }
}

.w1020 {
  .model-text {
    p {
      font-size: 18px;
    }
  }

  .model-button {
    button {
      font-size: 12px;
      height: 30px;
    }
  }

  .try-txt {
    height: 60px;
    line-height: 40px;
    font-size: 12px;
  }
}

.w860 {
  .model-text {
    p {
      font-size: 14px;
    }
  }

  .model-button {
    button {
      font-size: 12px;
      height: 30px;
    }
  }

  .try-txt {
    height: 56px;
    line-height: 36px;
    font-size: 12px;
  }
}

.cursor {
  cursor: pointer;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.8);

  .viewer-video-wrapper {
    background-color: black;
    position: relative;

    .viewer-video-close {
      display: inline-block;
      width: 36px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 50%;
      font-size: 20px;
      font-weight: bold;
      color: rgb(203, 106, 34);
      box-shadow: 0px 1px 3px 0px rgba(148, 140, 98, 0.72);
      background: #FFF;
      position: absolute;
      cursor: pointer;
    }

    .playerWrapper {
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
}
</style>


